export default __webpack_public_path__ + "static/home-woman-hero-0e676fb45a09c2e3d22d68e1e0bdfd86.svg";